import { deriveClaimRightsMintPda } from '@morfi/contract-sdk';
import { PublicKey } from '@solana/web3.js';
import { logger } from '@/lib/telemetry/logger';

/**
 * Claim-rights mints are deterministic contract PDAs, so clients can read the
 * wallet's exact burnable balance without adding the mint to the position DTO.
 */
export function claimRightsMintAddress(
  marketAddress: string,
  outcomeIndex: number,
): string | undefined {
  if (!Number.isInteger(outcomeIndex) || outcomeIndex < 0 || outcomeIndex > 255) return undefined;

  try {
    const [mint] = deriveClaimRightsMintPda(new PublicKey(marketAddress), outcomeIndex);
    return mint.toBase58();
  } catch (error) {
    logger.warn('claim_rights_mint_address_unavailable', {
      marketAddress,
      outcomeIndex,
      errorName: error instanceof Error ? error.name : 'non_error',
    });
    return undefined;
  }
}
